import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "l-landing" };
const _hoisted_2 = { class: "l-content" };
const _hoisted_3 = { class: "h5 l-content_title text-white text-center mb-3" };
const _hoisted_4 = { class: "l-content__text text-center" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = { class: "l-content" };
const _hoisted_7 = { class: "d-grid d-sm-flex align-items-center l-content__ordering" };
const _hoisted_8 = {
    key: 0,
    class: "small fa-solid fa-sort-up text-secondary up"
};
const _hoisted_9 = {
    key: 1,
    class: "small fa-solid fa-sort-down text-secondary down"
};
const _hoisted_10 = {
    key: 0,
    class: "small fa-solid fa-sort-up text-secondary up"
};
const _hoisted_11 = {
    key: 1,
    class: "small fa-solid fa-sort-down text-secondary down"
};
const _hoisted_12 = {
    key: 0,
    class: "table-responsive"
};
const _hoisted_13 = { class: "text-nowrap" };
const _hoisted_14 = { class: "text-nowrap" };
const _hoisted_15 = { class: "text-nowrap text-center" };
const _hoisted_16 = { class: "text-nowrap text-center" };
const _hoisted_17 = { class: "text-nowrap text-center" };
const _hoisted_18 = { class: "l-item" };
const _hoisted_19 = { class: "position-relative" };
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = ["href"];
const _hoisted_22 = { class: "text-white align-middle position-relative" };
const _hoisted_23 = ["href"];
const _hoisted_24 = { class: "text-white text-center align-middle position-relative" };
const _hoisted_25 = ["href"];
const _hoisted_26 = { class: "text-white text-center align-middle position-relative" };
const _hoisted_27 = ["href"];
const _hoisted_28 = { class: "text-center align-middle position-relative" };
const _hoisted_29 = {
    type: "button",
    class: "btn btn-outline-white l-item__btn"
};
const _hoisted_30 = ["href"];
const _hoisted_31 = {
    key: 0,
    class: "d-flex justify-content-center"
};
const _hoisted_32 = {
    key: 1,
    class: "text-center"
};
import { DateTime } from 'luxon';
import { onMounted, ref } from 'vue';
import VuePagination from '@asika32764/vue-pagination';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LandingContent',
    props: {
        page: {},
        order: {},
        dir: {}
    },
    setup(__props) {
        const props = __props;
        const root = ref();
        const loading = ref(false);
        const items = ref();
        const pagination = ref(0);
        const total = ref(0);
        const currentPage = ref(1);
        const order = ref(props.order);
        const dir = ref(props.dir);
        const bannerText = u.data('bannerText');
        onMounted(async () => {
            if (order.value === 'lang.title') {
                nameDir.value = props.dir;
            }
            if (order.value === 'protocol.last_update') {
                dateDir.value = props.dir;
            }
            await loadItems();
            if (props.page !== 1) {
                await pageChange(props.page);
            }
        });
        async function loadItems() {
            await updateUrl();
            await fetchItems();
        }
        async function fetchItems() {
            try {
                loading.value = true;
                const res = await u.$http.get(`@protocol_ajax/loadProtocolList`, {
                    params: {
                        page: currentPage.value,
                        order: order.value,
                        dir: dir.value
                    }
                });
                items.value = prepareItemList(res.data.data.items);
                pagination.value = res.data.data.pagination;
                total.value = res.data.data.total;
            }
            catch (e) {
                console.error(e);
                swal(e.message, '', 'warning');
            }
            finally {
                loading.value = false;
            }
        }
        function prepareItemList(items) {
            items.forEach((item) => {
                item.lastUpdate = DateTime.fromISO(item.lastUpdate).toISODate();
            });
            return items;
        }
        async function pageChange(event) {
            window.scrollTo({
                top: root.value.getBoundingClientRect().x + 190,
                behavior: 'smooth'
            });
            currentPage.value = event;
            return loadItems();
        }
        async function updateUrl() {
            const url = new URL(location.href);
            if (url.searchParams.get('q')) {
                url.searchParams.delete('q');
            }
            url.searchParams.set('page', currentPage.value.toString());
            url.searchParams.set('order', order.value);
            url.searchParams.set('dir', dir.value);
            u.$router.push({
                state: {
                    page: currentPage.value,
                    order: order.value,
                    dir: dir.value,
                },
                uri: url.toString()
            });
        }
        const nameDir = ref('');
        function sortByName() {
            dateDir.value = '';
            switch (nameDir.value) {
                case '':
                    nameDir.value = 'ASC';
                    break;
                case 'ASC':
                    nameDir.value = 'DESC';
                    break;
                case 'DESC':
                    nameDir.value = '';
                    break;
            }
            if (nameDir.value === '') {
                sort('protocol.ordering', 'ASC');
            }
            else {
                sort('lang.title', nameDir.value);
            }
        }
        const dateDir = ref('');
        function sortByDate() {
            nameDir.value = '';
            switch (dateDir.value) {
                case '':
                    dateDir.value = 'ASC';
                    break;
                case 'ASC':
                    dateDir.value = 'DESC';
                    break;
                case 'DESC':
                    dateDir.value = '';
                    break;
            }
            if (dateDir.value === '') {
                sort('protocol.ordering', 'ASC');
            }
            else {
                sort('protocol.last_update', dateDir.value);
            }
        }
        async function sort(orderType, dirType) {
            order.value = orderType;
            dir.value = dirType;
            await pageChange(1);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$lang('datavideo.protocol.list.welcome')), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            innerHTML: _ctx.$nl2br(_unref(bannerText))
                        }, null, 8, _hoisted_5)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-gray l-content__sort position-relative mb-3 mb-sm-0 me-sm-3",
                            onClick: _cache[0] || (_cache[0] = ($event) => (sortByName()))
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["small mr-3", nameDir.value !== '' ? `text-secondary` : ''])
                            }, _toDisplayString(_ctx.$lang('datavideo.protocol.list.sort.by.name')), 3),
                            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "small fa-solid fa-sort" }, null, -1)),
                            (nameDir.value === `ASC`)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                : _createCommentVNode("", true),
                            (nameDir.value === `DESC`)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-gray l-content__sort position-relative",
                            onClick: _cache[1] || (_cache[1] = ($event) => (sortByDate()))
                        }, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["small mr-3", dateDir.value !== '' ? `text-secondary` : ''])
                            }, _toDisplayString(_ctx.$lang('datavideo.protocol.list.sort.by.date')), 3),
                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "small fa-solid fa-sort" }, null, -1)),
                            (dateDir.value === `ASC`)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                                : _createCommentVNode("", true),
                            (dateDir.value === `DESC`)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (!loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("table", {
                                class: "table l-table",
                                id: "protocol-items",
                                ref_key: "root",
                                ref: root
                            }, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.image')), 1),
                                        _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.name')), 1),
                                        _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.version.number')), 1),
                                        _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.last.update')), 1),
                                        _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$lang('datavideo.protocol.list.label.page')), 1)
                                    ])
                                ]),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                            _createElementVNode("td", _hoisted_19, [
                                                _createElementVNode("img", {
                                                    src: item.image,
                                                    class: "l-item__img",
                                                    alt: item.title
                                                }, null, 8, _hoisted_20),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[5] || (_cache[5] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_21)
                                            ]),
                                            _createElementVNode("td", _hoisted_22, [
                                                _createElementVNode("div", null, _toDisplayString(item.category_lang_title), 1),
                                                _createElementVNode("div", null, _toDisplayString(item.title), 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[6] || (_cache[6] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_23)
                                            ]),
                                            _createElementVNode("td", _hoisted_24, [
                                                _createTextVNode(_toDisplayString(item.version) + " ", 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[7] || (_cache[7] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_25)
                                            ]),
                                            _createElementVNode("td", _hoisted_26, [
                                                _createTextVNode(_toDisplayString(item.lastUpdate) + " ", 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[8] || (_cache[8] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_27)
                                            ]),
                                            _createElementVNode("td", _hoisted_28, [
                                                _createElementVNode("button", _hoisted_29, _toDisplayString(_ctx.$lang('datavideo.protocol.list.link')), 1),
                                                _createElementVNode("a", {
                                                    href: item.url,
                                                    class: "stretched-link"
                                                }, _cache[9] || (_cache[9] = [
                                                    _createElementVNode("span", { class: "d-none" }, "Link", -1)
                                                ]), 8, _hoisted_30)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ], 512),
                            (items.value?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createVNode(_unref(VuePagination), {
                                        modelValue: currentPage.value,
                                        "onUpdate:modelValue": [
                                            _cache[2] || (_cache[2] = ($event) => ((currentPage).value = $event)),
                                            pageChange
                                        ],
                                        total: total.value,
                                        "per-page": 10,
                                        class: "pagination",
                                        "item-class": "page-item",
                                        "link-class": "page-link",
                                        "active-class": "active",
                                        "disabled-class": "disabled"
                                    }, {
                                        "first-icon": _withCtx(() => _cache[10] || (_cache[10] = [
                                            _createTextVNode(" « ")
                                        ])),
                                        "previous-icon": _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode(" ‹ ")
                                        ])),
                                        "next-icon": _withCtx(() => _cache[12] || (_cache[12] = [
                                            _createTextVNode(" › ")
                                        ])),
                                        "last-icon": _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode(" » ")
                                        ])),
                                        _: 1
                                    }, 8, ["modelValue", "total"])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[14] || (_cache[14] = [
                            _createElementVNode("div", {
                                class: "spinner-border text-light",
                                role: "status"
                            }, [
                                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                            ], -1)
                        ])))
                ])
            ]));
        };
    }
});
